import { Column, FMColumn } from '../model';

import { MisleadLevelCellInner } from '../components/cells/MisleadLevelCell';

import { FilterEnumContainer } from '../components/plugins/filters/FilterEnumContainer';
import { misleadSingleton } from '../../app/misleadSingleton';
import { Type } from '../../../../general/modules/filter/dataModel';
import { WithLoader } from '../components/cells/WithLoader';

export const misleadLevelCol: FMColumn<Type.ID> = {
  key: Column.mislead_level,
  dataKey: Column.mislead_level,
  title: 'Mislead',
  width: 115,
  sortable: true,
  cellRenderer: WithLoader(MisleadLevelCellInner),
  className: 'ch-file-manager__cell_mislead_level',
  plugins: [FilterEnumContainer],
  filter: Type.ID,
  getter: (row) => row.creative?.mislead_level ?? null,
  toDisplayString: (row) => {
    const misleadLevel = row.creative?.mislead_level ?? null;
    if (misleadLevel === null) return null;

    const item = misleadSingleton.findById(misleadLevel);
    if (!item) return null;

    return item.name;
  },
};
